import API, { defaultHeaders } from '../';
import Storage from '@/service/Storage';

const addInvitationCode = code => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${Storage.getItem('token')}`;
  return fetch(`${API}/invitation/assign-user/${code}`, {
    method: 'put',
    headers,
  });
};

export default addInvitationCode;
